import React from "react";
import EmployeeForm from "./EmployeeForm";

const Update = () => {
    return <EmployeeForm mode="edit" />;
};

export default Update;